import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

interface InviteValue {
  slug: string
  repo: string
  isActive: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'new',
  setup(__props) {

definePageMeta({ layout: false })
useHead({ title: 'New invite - admin - Daniel Roe' })

async function save (value: InviteValue) {
  await $fetch('/api/admin/invites', { method: 'POST', body: value })
  await navigateTo('/admin/invites')
}

return (_ctx: any,_cache: any) => {
  const _component_AdminInviteForm = _resolveComponent("AdminInviteForm")!
  const _component_AdminShell = _resolveComponent("AdminShell")!

  return (_openBlock(), _createBlock(_component_AdminShell, { title: "New invite" }, {
    default: _withCtx(() => [
      _createVNode(_component_AdminInviteForm, {
        "submit-label": "Create",
        onSubmit: save
      })
    ]),
    _: 1
  }))
}
}

})